import { PageStateModel } from "./page-state-model";

export class ActionCenterModel {
    MyActions: PageStateModel | undefined;
    Recommended: PageStateModel | undefined;
    Completed: PageStateModel | undefined;
    Dismissed: PageStateModel | undefined;
    Snoozed: PageStateModel | undefined;

    constructor(
        myActions: PageStateModel | undefined = undefined,
        recommended: PageStateModel | undefined = undefined,
        completed: PageStateModel | undefined = undefined,
        dismissed: PageStateModel | undefined = undefined,
        snoozed: PageStateModel | undefined = undefined
    ) {
        this.MyActions = myActions;
        this.Recommended = recommended;
        this.Completed = completed;
        this.Dismissed = dismissed;
        this.Snoozed = snoozed;
    }

    // Check if the model is empty
    isEmpty(): boolean {
        return this.MyActions === undefined && this.Recommended === undefined && this.Completed === undefined && this.Dismissed === undefined && this.Snoozed === undefined;
    }
}